import { instantsInterceptor, } from '@/api/index';

function getFeedbackList(page) {
    return instantsInterceptor.post('/service/mylibrary/feedback/list', { page: page });
}

function deleteFeedback(feedback) {
    return instantsInterceptor.post('/service/mylibrary/feedback/delete', feedback);
}

function deleteMgmtFeedback(feedback) {
    return instantsInterceptor.post('/mgmt/feedback/delete', feedback);
}

function getMgmtFeedbackList(form) {
    return instantsInterceptor.post('/mgmt/feedback/list', form);
}

function saveFeedbackAnswer(feedback) {
    return instantsInterceptor.post('/mgmt/feedback/save/answer', feedback);
}

function getMyFeedbackAuth() {
    return instantsInterceptor.get('/mgmt/feedback/manager');
}

function getFeedbackManager() {
    return instantsInterceptor.get('/mgmt/feedback/manager/list');
}

function saveFeedbackManager(feedbackMem) {
    return instantsInterceptor.post('/mgmt/feedback/manager/save', feedbackMem);
}

function getMgmtFeedbackAnswerList(form) {
    return instantsInterceptor.post('/mgmt/feedback/answer/list', form);
}

export {
    getFeedbackList,
    deleteFeedback,
    getMgmtFeedbackList,
    saveFeedbackAnswer,
    deleteMgmtFeedback,
    getMyFeedbackAuth,
    getFeedbackManager,
    saveFeedbackManager,
    getMgmtFeedbackAnswerList
};